export class CommunicationPhoneTypeReferenceModel {
    public communicationPhoneTypeCode: string;
    public communicationPhoneTypeName: string;
    public primaryFlag: boolean;
    public sortSequence: number;
    public statusCode: string;
}
